/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureDetail } from './CaptureDetail';
import {
    CaptureDetailFromJSON,
    CaptureDetailFromJSONTyped,
    CaptureDetailToJSON,
    CaptureDetailToJSONTyped,
} from './CaptureDetail';

/**
 * 
 * @export
 * @interface GetCapturesResponse
 */
export interface GetCapturesResponse {
    /**
     * 
     */
    captures: Array<CaptureDetail>;
}

/**
 * Check if a given object implements the GetCapturesResponse interface.
 */
export function instanceOfGetCapturesResponse(value: object): value is GetCapturesResponse {
    if (!('captures' in value) || value['captures'] === undefined) return false;
    return true;
}

export function GetCapturesResponseFromJSON(json: any): GetCapturesResponse {
    return GetCapturesResponseFromJSONTyped(json, false);
}

export function GetCapturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCapturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'captures': ((json['captures'] as Array<any>).map(CaptureDetailFromJSON)),
    };
}

export function GetCapturesResponseToJSON(json: any): GetCapturesResponse {
    return GetCapturesResponseToJSONTyped(json, false);
}

export function GetCapturesResponseToJSONTyped(value?: GetCapturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'captures': ((value['captures'] as Array<any>).map(CaptureDetailToJSON)),
    };
}

